import yurinya from '../image/yurinya_icon.png';
import nenesan from '../image/nenesan_icon.png';
import kyon from '../image/kyon_icon.png';
import yuna from '../image/yuna_icon.png';
import yakan from '../image/yakan_icon.png';
import sappi from '../image/sappi_icon.png';
import mayu from '../image/mayu_icon.png';
import manat from '../image/manat_icon.png';

export const DIALOGUE_ARRAY = [
  {name: 'yurinya', color: '#f39aab', supportProbability: 13, imgSrc: yurinya},
  {name: 'nenesan', color: '#ffd93c', supportProbability: 9, imgSrc: nenesan},
  {name: 'kyon', color: '#cfd10c', supportProbability: 13, imgSrc: kyon},
  {name: 'yuna', color: '#15addc', supportProbability: 13, imgSrc: yuna},
  {name: 'yakan', color: '#ff9700', supportProbability: 13, imgSrc: yakan},
  {name: 'sappi', color: '#f15183', supportProbability: 13, imgSrc: sappi},
  {name: 'mayu', color: '#80c4ed', supportProbability: 13, imgSrc: mayu},
  {name: 'manat', color: '#a269a8', supportProbability: 13, imgSrc: manat},
]